<button mat-stroked-button color="primary" [matMenuTriggerFor]="matMenuTriggerFor" #mobileActionsMenuTrigger="matMenuTrigger">
  <mat-icon [svgIcon]="mobileActionsMenuTrigger.menuOpen ? 'chevron_up' : 'chevron_down'" />
  {{ 'shared.actions' | translate }}
</button>
